import SecurityTopics from "./SecurityTopics";

export default SecurityTopics;
